import API from 'services/API';

export default function getAccountSign() {
  return API.request({
    method: 'GET',
    url: `/dicts/accountSign`,
  });
}
